import { Box, Flex } from '@modusign/design-system';

import DocumentZoomButton from '@app/components/DocumentZoomButton';
import Header from '@app/components/Header';
import HelpButton from '@app/components/HelpButton';
import StepProgressBar from '@app/components/StepProgressBar';
import TemplateHeaderDivider from '@app/components/TemplateHeaderDivider';
import TutorialButton from '@app/components/TutorialButton';
import ExchangeDocumentFileButton from '@app/features/template/components/ExchangeDocumentFileButton';

interface TemplateHeaderProps {
  isExchangeDocumentVisible?: boolean;
  currentStepIndex: number;
  progressStep: 'templateParticipantSetup' | 'templateFieldSetup' | 'templateGeneralSetup';
  onPDFZoomIn: () => void;
  onPDFZoomOut: () => void;
}

const defaultProps = {
  showZoomButtons: false,
  onPDFZoomIn() {},
  onPDFZoomOut() {},
};

const steps = ['서명자 설정', '입력 설정', '기타 설정'];

function TemplateHeader({
  isExchangeDocumentVisible,
  currentStepIndex,
  progressStep,
  onPDFZoomIn,
  onPDFZoomOut,
}: TemplateHeaderProps) {
  function handlePDFZoomIn() {
    onPDFZoomIn();
  }

  function handlePDFZoomOut() {
    onPDFZoomOut();
  }

  return (
    <>
      <Header>
        <Flex flex={[0, null, 1]} />
        <Flex
          alignItems="center"
          flex="1"
          justifyContent={[null, null, 'center']}
          px={2}
          py={5}
          textAlign="center"
        >
          <StepProgressBar currentStepIndex={currentStepIndex} steps={steps} />
        </Flex>
        <Flex flex="1" justifyContent="flex-end">
          <Box pr={4}>
            <Flex alignItems="center" height="100%" textAlign="right">
              <TutorialButton
                className={`tag${progressStep.charAt(0).toUpperCase()}${progressStep.slice(
                  1
                )}TutorialButton`}
                variant="dark"
              />
              <TemplateHeaderDivider />
              {progressStep === 'templateFieldSetup' && (
                <>
                  {isExchangeDocumentVisible && (
                    <>
                      <ExchangeDocumentFileButton />
                      <TemplateHeaderDivider />
                    </>
                  )}
                  <DocumentZoomButton onZoomIn={handlePDFZoomIn} onZoomOut={handlePDFZoomOut} />
                </>
              )}
              <TemplateHeaderDivider />
              <HelpButton variant="darkIcon" />
            </Flex>
          </Box>
        </Flex>
      </Header>
    </>
  );
}

TemplateHeader.defaultProps = defaultProps;

export default TemplateHeader;
